import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ServiciosService } from 'app/services/servicios.service';

@Component({
  selector: 'app-orden-csc',
  templateUrl: './orden-csc.component.html',
  styleUrls: ['./orden-csc.component.scss']
})
export class OrdenCscComponent implements OnInit {

  public ordenCsc;
  public csc;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private serviciosService: ServiciosService) { }

  ngOnInit() {
  }

  enviarOrdenCsc(){
    this.csc = this.datos.consec;
    this.serviciosService.ordenCSC(this.csc, this.ordenCsc);
  }

}
